import React from 'react'

import { Fieldset, PaymentProvidersIcons } from '@fourthwall/components'

import type { CardField } from '../../AddPaymentMethod.types'
import { StripeField } from '../StripeField/StripeField'
import * as S from './StripeForm.styled'

export type StripeFormProps = {
  fields: {
    cardNumber: CardField
    cardExpiry: CardField
    cardCvc: CardField
  }
}

export const StripeForm = ({ fields }: StripeFormProps) => {
  return (
    <>
      <Fieldset.Row>
        <Fieldset.Item>
          <StripeField
            field={fields.cardNumber}
            append={
              <S.CardIconsWrapper>
                <PaymentProvidersIcons type={['creditCards']} />
              </S.CardIconsWrapper>
            }
          />
        </Fieldset.Item>
      </Fieldset.Row>
      <Fieldset.Row>
        <Fieldset.Item>
          <StripeField field={fields.cardExpiry} />
        </Fieldset.Item>
        <Fieldset.Item>
          <StripeField field={fields.cardCvc} />
        </Fieldset.Item>
      </Fieldset.Row>
    </>
  )
}
